// Lightweight theme manager. Stores preference in localStorage and applies
// data-theme attribute on <html>. Dark mode is opt-in and styled via index.css.
const KEY = "adn:theme";

export function getStoredTheme() {
  try { return localStorage.getItem(KEY) || "system"; } catch { return "system"; }
}

export function resolveTheme(pref) {
  if (pref === "dark") return "dark";
  if (pref === "light") return "light";
  // system
  const prefersDark = typeof window !== "undefined"
    && window.matchMedia
    && window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
}

export function applyTheme(pref) {
  const resolved = resolveTheme(pref);
  if (typeof document !== "undefined") {
    document.documentElement.setAttribute("data-theme", resolved);
  }
  return resolved;
}

export function setTheme(pref) {
  try { localStorage.setItem(KEY, pref); } catch {}
  return applyTheme(pref);
}

// Apply once at module load so initial paint matches preference
if (typeof document !== "undefined") {
  applyTheme(getStoredTheme());
}
